/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { get } from "lodash";
import FieldContainer from "../field-container/field-container";
import { TemplateFieldErrors } from "../shared-types";
import { Fields } from "api/content-templates";

const templateFieldsToDisplay = [
  { label: "Title", path: "headline", hasCharacterLength: true },
  { label: "Subtitle", path: "subheadline", hasCharacterLength: true },
  { label: "Sections", path: "sections", hasCharacterLength: false },
  { label: "Tags", path: "tags", hasCharacterLength: false },
  // { label: "Subtitle", path: "instant-articles-video-fields" },
  { label: "Meta Keywords", path: "meta-keywords", hasCharacterLength: false },
  { label: "Meta Description", path: "meta-description", hasCharacterLength: true },
  { label: "Meta Title", path: "meta-title", hasCharacterLength: true },
  { label: "Author", path: "author", hasCharacterLength: false },
  { label: "Social Share", path: "summary", hasCharacterLength: true },
  { label: "Canonical URL", path: "canonical-url", hasCharacterLength: false },
  { label: "Custom URL", path: "custom-url", hasCharacterLength: false },
  { label: "Hero Image", path: "hero-image-s3-key", hasCharacterLength: false },
  { label: "Sponsored By", path: "sponsored-by", hasCharacterLength: false }
];

const templateImageFieldsToDisplay = [
  { label: "Hero Image Attribution", path: "hero-image-attribution", hasCharacterLength: true },
  { label: "Hero Image Caption", path: "hero-image-caption", hasCharacterLength: true },
  { label: "Hero Image Focus Point", path: "hero-image-focus-point", hasCharacterLength: false }
];

interface Props {
  onFieldChange: (key: string, value: Object) => void;
  fields: Fields;
  setErrors: (errors: Object) => void;
  errors: TemplateFieldErrors;
}

const TemplateFields: React.SFC<Props> = ({ fields, onFieldChange, setErrors, errors }) => {
  const isHeroImageHidden = get(fields, ["hero-image-s3-key", "validations", "hidden"]);
  return (
    <React.Fragment>
      {templateFieldsToDisplay.map((fieldToDisplay, index) => (
        <FieldContainer
          key={index}
          id={index}
          fieldToDisplay={fieldToDisplay}
          field={fields[fieldToDisplay.path]}
          onFieldChange={onFieldChange}
          setErrors={setErrors}
          errors={errors}
        />
      ))}
      {!isHeroImageHidden &&
        templateImageFieldsToDisplay.map((fieldToDisplay, index) => (
          <FieldContainer
            key={index}
            id={index}
            fieldToDisplay={fieldToDisplay}
            field={fields[fieldToDisplay.path]}
            onFieldChange={onFieldChange}
            setErrors={setErrors}
            errors={errors}
          />
        ))}
    </React.Fragment>
  );
};

export default TemplateFields;
